import { SpecialFreightIdView } from '../../../../models';

export class ShipmentSpecialFreightTrackingLoad {
  public static readonly type = '[ShipmentSpecialFreightTracking] Load Tracking';
  constructor(public payload: SpecialFreightIdView) {}
}

export class ShipmentSpecialFreightTrackingSetInitialState {
  public static readonly type = '[ShipmentSpecialFreightTracking] Set Initial State';
}
